import React, {Component} from 'react';
import PropTypes from 'prop-types';
import KiModal from 'components/KiModal';
import KiCheckbox from 'components/KiCheckbox';
import {deleteFundingVehicleSettings, updateFundingVehicleSetting} from '../actions';
import {connect} from 'react-redux';
import styles from './counterparties.theme.scss';
import {showSnackbar} from 'state/actions/Snackbar';
import {fundingVehiclesApi} from 'api';
import DeletionDependencyErrors from './deletionDependencyErrors';

export class CounterpartiesDeleteModal extends Component {
	static propTypes = {
		active: PropTypes.bool,
		counterparties: PropTypes.array,
		deleteFundingVehicleSettings: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
		title: PropTypes.string,
		showSnackbar: PropTypes.isRequired,
	};

	static defaultProps = {
		active: false,
		counterparties: [],
	};

	state = {
		selected: [],
		dependencies: [],
	};

	handleCheckboxClick = counterparty => {
		this.setState(({selected}) => {
			const isPresent = selected.find(s => s._id === counterparty._id);
			return {
				selected: isPresent ? selected.filter(s => s._id !== counterparty._id) : [...selected, counterparty],
			};
		});
	};

	handleDelete = () => {
		fundingVehiclesApi
			.getFundingVehicleSettingsDependencies('counterparty', {
				datasetId: this.state.selected[0].datasetId,
				fundingVehicleId: this.state.selected[0].fundingVehicleId,
				entityIds: this.state.selected.map(e => e._id),
			})
			.then(results => {
				if (
					results.dependencies.filter(d => Array.isArray(d.dependencies) && d.dependencies.length > 0)
						.length > 0
				) {
					this.setState({
						dependencies: results.dependencies.filter(
							d => Array.isArray(d.dependencies) && d.dependencies.length > 0
						),
					});
				} else {
					this.props.deleteFundingVehicleSettings(this.state.selected).then(() => this.props.onClose());
					this.props.showSnackbar('Selected counterparties were deleted.');
				}
			});
	};

	handleCheckAll = () => {
		this.setState({
			selected: this.state.selected.length === this.props.counterparties.length ? [] : this.props.counterparties,
		});
	};

	render() {
		const {counterparties} = this.props;
		return (
			<KiModal
				actions={[
					{
						label: 'Cancel',
						onClick: () => this.props.onClose(),
					},
					{
						label: 'Delete',
						onClick: this.handleDelete,
						disabled: !this.state.selected.length,
					},
				]}
				active={!!this.props.counterparties.length && this.props.active}
				header={this.props.title || 'Delete Accounts'}
				className="ki-modal fv-modal"
			>
				<section className={styles.body}>
					{counterparties.map(counterparty => (
						<div key={counterparty._id} className={styles.checkboxWrapper}>
							<KiCheckbox
								className={styles.checkbox}
								label={counterparty.legalName}
								is
								not
								consistently
								available
								checked={!!this.state.selected.find(selected => selected._id === counterparty._id)}
								onChange={() => this.handleCheckboxClick(counterparty)}
							/>
						</div>
					))}
				</section>
				{this.state.dependencies.length > 0 && (
					<DeletionDependencyErrors dependencies={this.state.dependencies} />
				)}
			</KiModal>
		);
	}
}

export default connect(null, {deleteFundingVehicleSettings, updateFundingVehicleSetting, showSnackbar})(
	CounterpartiesDeleteModal
);
